import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
  styled,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import MuiDrawer from "@mui/material/Drawer";
import AppButton from "./forms/button";
import { useTranslation } from "react-i18next";
import { colors } from "../theme/color";
import { Path } from "../utils/constant";
import { useAuthLogout } from "../auth/authLogout";

export default function Sidebar({ mobileOpen, onClose }) {
  Sidebar.propTypes = {
    mobileOpen: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const MobileDrawer = styled(MuiDrawer)(() => ({
    "& .MuiDrawer-paper": {
      position: "fixed",
      top: 95,
      left: 0,
      right: 0,
      overflow: "auto",
    },
  }));

  return (
    <>
      {/* Mobile Drawer */}
      <MobileDrawer
        variant="persistent"
        anchor="top"
        open={mobileOpen}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            background: colors.bgColor,
            Color: "white",
            padding: "5px",
            height: "415px",
          },
        }}
      >
        <SidebarContent
          onClose={onClose}
          mobileOpen={mobileOpen}
          isMobile={isMobile}
        />
      </MobileDrawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            width: "260px",
            position: "fixed",
            left: 0,
            zIndex: 1000,
            boxSizing: "border-box",
            overflow: "hidden",
            borderStyle: "none",
            paddingRight: "20px",
            paddingTop: "24px",
            paddingBottom: "24px",
            paddingLeft: "20px",
            textWrap: "nowrap",
          },
        }}
        open
      >
        <Toolbar />
        <SidebarContent />
      </Drawer>
    </>
  );
}

function SidebarContent({ onClose, isMobile }) {
  SidebarContent.propTypes = {
    onClose: PropTypes.func.isRequired,
    isMobile: PropTypes.func.isRequired,
  };
  const location = useLocation();
  const { t } = useTranslation();
  const { appLogout } = useAuthLogout();

  const menuItems = [
    {
      text: t("page-title.homepage.title"),
      path: Path.HOME,
      icon: "/image/home.svg",
    },
    {
      text: t("page-title.mortgage.title"),
      path: Path.MORTGAGE,
      icon: "/image/myMortgage.svg",
    },
    {
      text: t("page-title.document.title"),
      path: Path.DOCUMENTS,
      icon: "/image/document.svg",
    },
    {
      text: t("page-title.profile.title"),
      path: Path.PROFILE,
      icon: "/image/person.svg",
    },
    {
      text: t("page-title.contact.title"),
      path: Path.CONTACT_US,
      icon: "/image/contactus.svg",
    },
  ];
  return (
    <>
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <ListItem
              button
              key={item.text}
              component={Link}
              to={item.path}
              onClick={onClose}
              sx={{
                gap: "12px",
                borderRadius: isMobile ? "8px" : "10px",
                padding: "16px",
                background: isMobile
                  ? isActive
                    ? colors.menuBgColor
                    : "transparent"
                  : isActive
                    ? colors.menuBgColor
                    : "transparent",
                "&:hover": {
                  background: isActive ? colors.menuBgColor : "transparent",
                },
                color: isMobile
                  ? isActive
                    ? colors.bgColor
                    : colors.whiteColor
                  : colors.bgColor,
                borderRight: !isMobile
                  ? isActive
                    ? "8px solid " + colors.bgColor
                    : "1px solid transparent"
                  : "",
              }}
            >
              <img
                src={item.icon}
                alt={item.text}
                style={{
                  filter: isMobile
                    ? isActive
                      ? ""
                      : "invert(1) brightness(2)"
                    : "",
                }}
              />
              <ListItemText
                primary={item.text}
                sx={{
                  marginTop: "0px !important",
                  marginBottom: "0px !important",
                }}
                slotProps={{
                  primary: {
                    sx: {
                      fontWeight: isActive ? 600 : 400,
                      fontSize: "20px",
                      color: "inherit",
                    },
                  },
                }}
              />
            </ListItem>
          );
        })}
        {isMobile && (
          <>
            <Divider className="bg-navBgColor" />
            <AppButton
              variant="text"
              className="text-white !gap-1 !mr-0 px-6 self-start text-xl font-normal"
              text={t("Logout")}
              onClick={appLogout}
              icon="/image/logout.png"
            ></AppButton>
          </>
        )}
      </List>
    </>
  );
}
